(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-2027-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ls-language-switcher')) {
    customElements.define('ls-language-switcher', class extends HTMLElement {
      connectedCallback() {
        const query = new URL(window.location.href).searchParams;
        const explicitPreview = this.dataset.editorPreview === 'true' || window.Shopify?.previewMode === true || !!document.getElementById('OnlineStorePreviewBarNextData') || query.has('preview_theme_id') || query.has('preview_key');
        if (explicitPreview) this.querySelectorAll('[data-preview-href]').forEach(link => { link.href = link.dataset.previewHref; });
        this.querySelector('[data-preview-languages]').hidden = !explicitPreview;
        this.querySelector('[data-published-languages]').hidden = explicitPreview;
        this.hidden = !explicitPreview && Number(this.dataset.publishedCount) < 2;
        this.events?.abort();
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        if (this.details) {
          const sync = () => this.summary.setAttribute('aria-expanded', String(this.details.open));
          this.details.addEventListener('toggle', sync, options);
          document.addEventListener('pointerdown', event => {
            if (this.details.open && !this.contains(event.target)) this.details.open = false;
          }, options);
          this.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.details.open) {
              event.preventDefault();
              this.details.open = false;
              this.summary.focus();
            }
          }, options);
          this.addEventListener('focusout', event => {
            if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
          }, options);
          sync();
        }
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-language-preview]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const destination = new URL(link.href);
          const current = new URL(window.location.href);
          current.searchParams.forEach((value,key) => {
            if (key !== 'preview_theme_id' && key !== 'locale' && key !== 'language_code') destination.searchParams.set(key,value);
          });
          link.href = destination.href;
        }, options);
      }
      disconnectedCallback() {this.events?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
